import React from "react";
import { getCaseStudyHomePreview } from "../../../utils/caseStudyUtils";

const CaseStudyCardOverlay = ({ casestudy }) => {
  const { tag, title } = getCaseStudyHomePreview(casestudy);

  return (
    <div className="case-desc">
      <span className="case-study-subheading">{tag}</span>
      <span className="case-study-heading">{title}</span>
    </div>
  );
};

export default CaseStudyCardOverlay;
